module.exports = __webpack_public_path__ + "1.5.0-unryo/img/nginx.1c28eea7.svg";